import { Injectable } from '@angular/core';
import { ConfigService } from '../../Services/config.service';
import { HttpServiceService } from '../../Services/http-service.service';

export interface selectedLoyaltyCard {
  cardInternalId: string;
  gulfAirMembership: string;
  isPrimaryCard: boolean;
  maskedCardNumber: string;
  pointsEarned: string;
  pointsExpiringInNextMonth:string;
  pointsExpiringInNextThreeMonths: string;
  pointsRedeemed: string;
  rewardsBalance: string;
  shadowAccount: string;
  partnerAccounts?: {
    partnerCode: string;
    partnerName: string;
    accountNumber: string;
  }[];
}

@Injectable({
  providedIn: 'root'
})
export class RewardsService {

  constructor(private http:HttpServiceService,private ConfigServices:ConfigService) { }

  public GetRewardsSummarURL:string="Rewards/GetRewardsSummary";
  public GetRewardsHistoryURL:string="Rewards/GetRewardsHistory";
  public GetRedeemMasterURL:string="Redeem/GetRedeemMaster";
  public LoyaltyPointsCalculatorURL:string="Account/LoyaltyPointsCalculator";
  public PointsRedemptionURL:string="Redeem/PointsRedemptionV4";
  public CheckPointsURL:string="Points/CheckPoints";
  public LoyaltyCard:selectedLoyaltyCard;

  // Transfer reference from the last redemption API response (for success screen)
  public lastRedemptionTransferReference: string = '';

  // Full redemption result from API response (for success screen)
  public lastRedemptionResult: {
    status: string;
    revisedAvailablePoints: string;
    transferReference: string;
    redeemType: string;
    selectedPoint: number | string;
    amount: string;
    partnerCode: string;
    category?: string;
    imageUrl?: string;
    perPointRate?: number;
    redemptionAmountBhd?: number;
  } | null = null;

  // In-memory holder for redeem flow data (avoid cookie round-trip)
  public pendingRedemption: {
    redeemType: string;
    redeemId: number;
    selectedPoint: number | string;
    amount: string;
    partnerCode: string;
    accountNumberRequired: boolean;
    redemptionAmountBhd: number;
    category?: string;
    imageUrl?: string;
    perPointRate?: number;
  } | null = null;


  public GetRewardsSummary(token){
   
    return new Promise((resolve,reject)=>{
      this.http.postToCloseApi(this.ConfigServices.server+this.GetRewardsSummarURL,{},token).subscribe((data)=>{

        resolve(data)
        console.log('GetRewardsSummar',data);
      },Error=>{
        resolve(Error);
        console.log('GetRewardsSummarError',Error);

      })



    })

  }


  public GetRewardsHistory(token,body){

    return new Promise((resolve,reject)=>{
      this.http.postToCloseApi(this.ConfigServices.server+this.GetRewardsHistoryURL,body,token).subscribe((data)=>{

        resolve(data)
        console.log('GetRewardsHistory',data);
      },Error=>{
        resolve(Error);
        console.log('GetRewardsHistoryError',Error);

      })



    })

  }
  public GetRedeemMaster(token,body){

    return new Promise((resolve,reject)=>{
      this.http.postToCloseApi(this.ConfigServices.server+this.GetRedeemMasterURL,body,token).subscribe((data)=>{

        resolve(data)
        console.log('GetRedeemMaster',data);
      },Error=>{
        resolve(Error);
        console.log('GetRedeemMasterError',Error);

      })



    })

  }
  public PointsRedemption(token,body){

    return new Promise((resolve,reject)=>{
      this.http.postToCloseApi(this.ConfigServices.server+this.PointsRedemptionURL,body,token).subscribe((data)=>{

        resolve(data)
        console.log('PointsRedemption',data);
      },Error=>{
        resolve(Error);
        console.log('PointsRedemptionError',Error);

      })



    })

  }

  public CheckPoints(token, body) {
    return new Promise((resolve, reject) => {
      this.http.postToCloseApi(this.ConfigServices.server + this.CheckPointsURL, body, token).subscribe((data) => {
        resolve(data);
        console.log('CheckPoints', data);
      }, Error => {
        resolve(Error);
        console.log('CheckPointsError', Error);
      });
    });
  }

  public LoyaltyPointsCalculator(token, body) {
    return new Promise((resolve, reject) => {
      this.http.postToCloseApi(this.ConfigServices.server + this.LoyaltyPointsCalculatorURL, body, token).subscribe((data) => {
        resolve(data);
        console.log('LoyaltyPointsCalculator', data);
      }, Error => {
        resolve(Error);
        console.log('LoyaltyPointsCalculatorError', Error);
      });
    });
  }
}




